angular.module('jv.services').service('evalSvc', function(){
	/*
	 * Process interview Eval list mode: required in root
	 */
	this.convertEvalToJson = function(interview){
		var xml2json = new X2JS();

		angular.forEach(interview.model.interviews, function(evaluationObj){

            //Remove the garbage HashKey data and manage the amps ans apos
            if(evaluationObj.evaluation){
            	evaluationObj.evaluation = evaluationObj.evaluation.replace(new RegExp('<\\$\\$hashKey>[0-9A-z]+</\\$\\$hashKey>','g'),'');
            	evaluationObj.evaluation = cleanMalformedURI(evaluationObj.evaluation);
            	evaluationObj.evaluation = evaluationObj.evaluation.replace(new RegExp("'s",'g'),'&apos;s');
            	evaluationObj.evaluation = evaluationObj.evaluation.replace(new RegExp("n't",'g'),'n&apos;t');
            	evaluationObj.evaluation = evaluationObj.evaluation.replace(new RegExp("&amp;amp;",'g'),'&amp;');
            	/*
            	 * REMOVE THE LINE LATER: 15572
            	 */
            	evaluationObj.evaluation = evaluationObj.evaluation.substring(evaluationObj.evaluation.indexOf('<evaluation>'));
            	evaluationObj.evaluation = evaluationObj.evaluation.substring(0, evaluationObj.evaluation.indexOf('</evaluation>')+13);

                var split = evaluationObj.evaluation.split('&');
                if(split.length > 1){
                	for(var i=1 ;i<split.length; i++){
                		if(split[i].indexOf(';') === -1 || split[i].indexOf(';') > 6){
                			split[i] = 'amp;'+split[i];
                		}
                    }
                }
                evaluationObj.evaluation = split.join('&');
            }

            if(!evaluationObj.details){
            	evaluationObj.details = xml2json.xml_str2json(evaluationObj.evaluation).evaluation;
            }

            var headerCount = 0;
            if(evaluationObj.details && evaluationObj.details.interview && evaluationObj.details.interview.header){
            	var evalXml = xml2json.parseXmlString(evaluationObj.evaluation);
            	for(var i=0; i<evalXml.childNodes.length; i++){
            		if(evalXml.childNodes[i] && evalXml.childNodes[i].nodeName === 'evaluation'){
            			for(var j=0; j<evalXml.childNodes[i].childNodes.length; j++){
            				var node = evalXml.childNodes[i].childNodes[j];
            				if(node.nodeName === 'interview'){
            					for(var k=0; k<node.childNodes.length; k++){
            						if(node.childNodes[k].nodeName === 'header'){
            							node.childNodes[k].setAttribute('index', k - headerCount);
            							headerCount ++;
            						}
            					}
            				}
            			}
            		}
            	}
            	evaluationObj.details = xml2json.xml2json(evalXml).evaluation;
            }
		});
	};

	/*
	 * create objects for interview List.
	 */
	this.transformInterviewEvaluations = function(interviewList){
		var obj = {
			list: [],
			stateIds:{}
		};

		for(var i=0; i<interviewList.length; i++){
			if(interviewList[i].model.interviews.length > -1){
				var startDate = null;
				var endDate = null;
				var id = interviewList[i].workflowElementInfo.EId;
				var elementName = interviewList[i].workflowElementInfo.elementName;
				elementName = elementName.charAt(0).toUpperCase()+elementName.slice(1);

				var data ={
					list:{},
					id:id,
					sendReminder: false,
					name: elementName
				};

				obj.stateIds[id] = angular.copy(interviewList[i]);
				if(obj.stateIds[id].model){
					obj.stateIds[id].model.interviews_completed = [];
				}else{
					obj.stateIds[id]={
						model:{
							interviews_completed: []
						}
					};
				}

				for(var j=0; j<interviewList[i].model.interviews.length; j++){
					var eId = interviewList[i].model.interviews[j].EId;
					var summary = interviewList[i].model.interviews[j].summary || '_NONE';

					var user = interviewList[i].model.interviews[j].user;
					user.actions = interviewList[i].model.interviewActions[eId] || [];
					user.evaluationId = eId;
					user.submitted = interviewList[i].model.interviews[j].submitted;

					if(interviewList[i].model.interviews[j].completed){
						data.list[summary] = data.list[summary] || [];
						data.list[summary].push(user);
						obj.stateIds[id].model.interviews_completed.push(interviewList[i].model.interviews[j]);
					}else{
						data.list['_PENDING'] = data.list['_PENDING'] || [];
						if(interviewList[i].model.interviews[j].interviewStatus !== 'Declined'){
							data.list['_PENDING'].push(user);	
						}
					}

					if((interviewList[i].model.interviews[j].duration && interviewList[i].model.interviews[j].duration > 0) && (!startDate)){
						startDate = new Date(interviewList[i].model.interviews[j].scheduleUtc);
					}

					if((interviewList[i].model.interviews[j].duration && interviewList[i].model.interviews[j].duration > 0) && startDate){
						endDate = new Date(interviewList[i].model.interviews[j].scheduleUtc);
					}
				}

				for(var j in interviewList[i].model.interviewActions){
					for(var k in interviewList[i].model.interviewActions[j]){
						if(interviewList[i].model.interviewActions[j][k].title === 'sendEvaluationReminder'){
							data.sendReminder = true;
						}
					}
				}

				if(startDate){
					obj.stateIds[id].model.startDate = startDate.getTime();
					if(endDate && (startDate.getDate() !== endDate.getDate() || startDate.getMonth() !== endDate.getMonth() || startDate.getYear() !== endDate.getYear())){
						obj.stateIds[id].model.endDate = endDate.getTime();
					}
				}

				obj.list.push(data);
			}
		}
		return angular.copy(obj);
	};

	/**
	 * TODO: this list of string should be fetched from BE. Use app.getProperty in jsp or something
	 */
	var cleanMalformedURI = function(str){
		var invalidChars = ['%01','%02','%03','%04', '%05','%06', '%07','%08', '%09', '%15', '%1C', '&#x[0-9]', '%0C', '%0B'];

		for(var i=0; i<invalidChars.length; i++){
			str = str.replace(new RegExp(decodeURI(invalidChars[i]),'g'),'');
		}

    	return str;
	};

	this.cleanMalformedURI = function(str){
		return cleanMalformedURI(str);
	};

});